import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { handleBackdropConfig, handleSnackBar } from "./global";
import MESSAGES from "../constants/messages";
// import { postAPICall } from '../utils/axios.util'
// import { nextAPIRoutes } from '../constants/apiRoutes'
import tractorService from "../services/tractor.service";
import imageService from "../services/image.service";

export const saveListingData = createAsyncThunk(
  "listing/saveListingData",
  async (
    { data, navigate, type }: { data: any; navigate: any; type?: number },
    { dispatch }
  ) => {
    try {
      let listingId: number = data.id;
      dispatch(handleBackdropConfig({ open: true }));
      dispatch(setSubmittingListingData(true));
      if (!data.id) {
        const tractorDraftId: any = await tractorService.createDraft({
          body: { type: type },
        });
        //  postAPICall(
        //   nextAPIRoutes.DRAFT_LISTING,
        //   { type: type },
        // )
        listingId = tractorDraftId?.data?.data?.id ?? 0;
      }

      console.log(listingId, "listingId");
      const resp: any = await tractorService.saveListing({
        body: {
          ...data,
          id: listingId,
        },
      });
      // postAPICall(nextAPIRoutes.SAVE_LISTING, {
      //   ...data,
      //   id: listingId,
      // })

      dispatch(getListingDetails({ id: listingId.toString(), softLoad: true }));
      dispatch(handleBackdropConfig({ open: false }));
      navigate();
      dispatch(setSubmittingListingData(false));
      return resp.data ?? [];
    } catch (e: any) {
      dispatch(setSubmittingListingData(false));
      dispatch(handleBackdropConfig({ open: false }));
      dispatch(
        handleSnackBar({
          open: true,
          severity: "error",
          message: e?.response?.data?.message ?? MESSAGES.ERROR,
        })
      );
      return [];
    }
  }
);

export const getListingDetails = createAsyncThunk(
  "listing/getListingDetails",
  async (
    { id, softLoad = false }: { id: string; softLoad?: boolean },
    { dispatch }
  ) => {
    try {
      if (!softLoad) {
        dispatch(setLoadingDetails(true));
      }
      const resp: any = await tractorService.listingDetails({ body: { id } });
      // postAPICall(nextAPIRoutes.LISTING_DETAILS, {
      //   id,
      // })
      dispatch(setLoadingDetails(false));
      dispatch(setListingExists(resp?.data?.data?.id ? true : false));

      return resp?.data?.data;
    } catch (e: any) {
      dispatch(setLoadingDetails(false));
      dispatch(setListingExists(false));
      dispatch(
        handleSnackBar({
          open: true,
          severity: "error",
          message: e?.response?.data?.message ?? MESSAGES.ERROR,
        })
      );
    }
  }
);

export const uploadListingImage = createAsyncThunk(
  "listing/uploadListingImage",
  async (
    {
      files,
      onSuccess,
      onError,
    }: { files: any; onSuccess: any; onError?: any },
    { dispatch }
  ) => {
    try {
      dispatch(handleBackdropConfig({ open: true }));
      const resp = await imageService.saveImage({
        body: {
          files: files.map((f: any) => ({
            ...f.uploadResp,
            listing_id: Number(f.id),
          })),
        },
      });
      // postAPICall(nextAPIRoutes.SAVE_IMAGES, {
      //   files: files.map((f: any) => ({
      //     ...f.uploadResp,
      //     listing_id: Number(f.id),
      //   })),
      // })
      // dispatch(getListingDetails({ id: files[0].id, softLoad: true }))
      onSuccess();
      // dispatch(getListingImg({ id }))
      dispatch(handleBackdropConfig({ open: false }));
      return resp.data ?? [];
    } catch (e: any) {
      onError();
      dispatch(handleBackdropConfig({ open: false }));
      dispatch(setSubmittingListingData(false));

      dispatch(
        handleSnackBar({
          open: true,
          severity: "error",
          message: e?.response?.data?.message ?? MESSAGES.ERROR,
        })
      );
      return [];
    }
  }
);

export const removeListingImage = createAsyncThunk(
  "listing/removeListingImage",
  async ({ id, onSuccess }: { id: string; onSuccess: any }, { dispatch }) => {
    try {
      dispatch(handleBackdropConfig({ open: true }));
      const resp: any = await imageService.removeImage({ body: { id } }); //postAPICall(nextAPIRoutes.REMOVE_IMAGE, { id })

      // dispatch(getListingImg({ id: listingId }))
      onSuccess();
      dispatch(handleBackdropConfig({ open: false }));
      return resp.data ?? [];
    } catch (e: any) {
      dispatch(handleBackdropConfig({ open: false }));
      dispatch(
        handleSnackBar({
          open: true,
          severity: "error",
          message: e?.response?.data?.message ?? MESSAGES.ERROR,
        })
      );
      return [];
    }
  }
);

export const getListingImg = createAsyncThunk(
  "listing/getListingImg",
  async ({ id }: { id: string }, { dispatch }) => {
    try {
      const resp: any = await imageService.getImage({ body: { id } });
      // postAPICall(nextAPIRoutes.GET_IMAGES, {
      //   id: id,
      // })
      return resp.data.data ?? [];
    } catch (e: any) {
      dispatch(
        handleSnackBar({
          open: true,
          severity: "error",
          message: e?.response?.data?.message ?? MESSAGES.ERROR,
        })
      );
      return [];
    }
  }
);

const listingSlice = createSlice({
  name: "listing",
  initialState: {
    step: 1,
    selectedType: 1,
    steps: [
      "Get started with some basic information",
      "Listing configuration",
      "Listing images",
      "Optional services",
      "Listing usage rates",
      "Pricing",
    ],
    submittingListingData: false,
    listingExists: false,
    loadingDetails: false,
    listingDetails: null,
    listingImages: [],
  },
  reducers: {
    setListingStep: (state, { payload }: { payload: number }) => {
      state.step = payload;
    },
    setListingType: (state, { payload }: { payload: number }) => {
      state.selectedType = payload;
    },
    setSubmittingListingData: (state, { payload }) => {
      state.submittingListingData = payload;
    },
    setListingExists: (state, { payload }) => {
      state.listingExists = payload;
    },
    setLoadingDetails: (state, { payload }) => {
      state.loadingDetails = payload;
    },
    clearListingData: (state) => {
      state.listingDetails = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getListingDetails.fulfilled, (state, { payload }) => {
        state.listingDetails = payload;
      })
      .addCase(getListingImg.fulfilled, (state, { payload }) => {
        state.listingImages = payload;
      });
  },
});

export default listingSlice.reducer;
export const {
  setSubmittingListingData,
  setListingExists,
  setLoadingDetails,
  setListingStep,
  setListingType,
  clearListingData,
} = listingSlice.actions;
